import { AgentInterface } from '@/services/Dossier/user/interfaces';
import { CreateReviewInterface, FeedbackReviewInterface } from '@/services/Dossier/review/interfaces';
import { ChatReviewInterface } from '@/services/QC-V2/chat/interfaces';
import { TicketReviewInterface } from '@/services/QC-V2/ticket/interfaces';
import { ReviewCommentInterface, ReviewTagInterface } from '@/services/QC-V2/ticket/interfaces';

export const feedbackEditorToolbar: unknown[] = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'underline', 'strike'],
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' },
  ],
  ['blockquote', 'code-block'],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ color: [] }, { background: [] }],
  ['clean'],
];

export interface DossierFeedbackChatCommentInterface {
  chatId: string;
  reviewId: number;
  commentId: number;
}

export interface DossierFeedbackTicketCommentInterface {
  ticketNumber: number;
  reviewId: number;
  commentId: number;
}

export interface FeedbackCategoryInterface {
  id: number;
  name: string;
}

export interface FeedbackTypeInterface {
  id: number;
  name: string;
}

export interface CreateAgentFeedbackInterface {
  categoryId: number;
  typeId: number;
  from: string;
  to: string;
  title: string;
  forMonth: string,
  reviews: CreateReviewInterface[];
  chatComments: DossierFeedbackChatCommentInterface[];
  ticketComments: DossierFeedbackTicketCommentInterface[];
}

export interface UpdateAgentFeedbackInterface {
  categoryId: number;
  typeId: number;
  title: string;
  forMonth: string,
  reviews: CreateReviewInterface[];
  chatComments: DossierFeedbackChatCommentInterface[];
  ticketComments: DossierFeedbackTicketCommentInterface[];
}

export interface FeedbackLogInterface {
  id: number;
  userId: string;
  action: string;
  date: string;
}

export interface AgentFeedbackInterface {
  id: number;
  category: FeedbackCategoryInterface;
  type: FeedbackTypeInterface;
  reviews: FeedbackReviewInterface[];
  chatComments: DossierFeedbackChatCommentInterface[];
  ticketComments: DossierFeedbackTicketCommentInterface[];
  from: AgentInterface;
  to: AgentInterface;
  title: string;
  date: string;
  forMonth: string;
  logs: FeedbackLogInterface[];
}

export interface FeedbackChatCommentInterface {
  chatId: string;
  reviewId: number;
  author: string;
  commentId: number;
  text: string;
  timestamp: string;
  review?: ChatReviewInterface | TicketReviewInterface;
}

export interface FeedbackTicketCommentInterface {
  ticketId: number;
  ticketNumber: number;
  reviewId: number;
  author: string;
  commentId: number;
  text: string;
  timestamp: string;
  review?: ChatReviewInterface | TicketReviewInterface;
}

export interface CommentsRequestParametersInterface {
  userId: string;
  excludeIds?: number[];
  months: string[];

  [key: string]: string | string[] | number | number[] | undefined;
}

export interface ChatCommentCreateInterface {
  chatId: string;
  reviewId: number;
  commentId: number;
  to: string;
  from: string;
}

export interface TicketCommentCreateInterface {
  ticketNumber: number;
  reviewId: number;
  commentId: number;
  to: string;
  from: string;
}


export interface AggregatedFeedbackChatComments {
  chatId: string;
  comments: ReviewCommentInterface[];
  tags?: ReviewTagInterface[];
}

export interface AggregatedFeedbackTicketComments {
  ticketId: number;
  ticketNumber: number;
  comments: ReviewCommentInterface[];
  tags?: ReviewTagInterface[];
}

export default interface DossierFeedbackRepositoryInterface {
  createFeedback(data: CreateAgentFeedbackInterface): Promise<AgentFeedbackInterface>;

  getFeedback(feedbackId: number): Promise<AgentFeedbackInterface>;

  updateFeedback(id: number, data: UpdateAgentFeedbackInterface): Promise<void>;

  deleteFeedback(id: number): Promise<void>;

  getFeedbackCategories(): Promise<FeedbackCategoryInterface[]>;

  getFeedbackTypes(): Promise<FeedbackTypeInterface[]>;

  createChatComment(data: ChatCommentCreateInterface): Promise<void>;

  createTicketComment(data: TicketCommentCreateInterface): Promise<void>;

  getChatComments(parameters: CommentsRequestParametersInterface): Promise<DossierFeedbackChatCommentInterface[]>;

  getTicketComments(parameters: CommentsRequestParametersInterface): Promise<DossierFeedbackTicketCommentInterface[]>;
}
